// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'myLocalFont', 'myLocalFont Fallback'"},"className":"__className_697c30","variable":"__variable_697c30"};